import React, { useEffect } from 'react';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { usePrevious } from '@vfgroup-oneplatform/foundation/Utils/Hooks';
import useMyPlanExtrasModal from '@vfgroup-oneplatform/framework/MyPlan/Hooks/useMyPlanExtrasModal';

import { PlanExtrasModal } from '../../Components';
import Config from '../../Components/PlanExtrasModal/PlanExtrasModalConfig.json';
import UserConfig from '../../Components/PlanExtrasModal/PlanExtrasModalUserConfig.json';
import Plan from '../Plan';

function PlanWithExtrasModal({
  onAddUsageClose,
  addExtraPlanData,
  onAddUsageConfirmationPress,
  planContainerStyle,
  isPlansExtrasLoading,
  plansExtrasError,
  plansExtrasErrorScreenProps,
  isUser,
  isCurrencyFirst,
  name,
  ...props
}) {
  const configFile = isUser ? UserConfig : Config;

  const {
    toggleModal,
    isVisible,
    closeModal,
    isLoading: isExtraPlanDataLoading,
    saveCardIsLoading,
    extraModalJson,
    handleConfirmButtonPress,
    isLoadingSuccessful,
    doneLoadingSubtitlePlaceholders,
    isResetData,
    paymentOptions,
    setPaymentOptions,
    loadingFailureError,
    toggleAddUsageModal,
  } = useMyPlanExtrasModal({
    Config: configFile,
    addExtraPlanData,
    onPressAddConfirmation: onAddUsageConfirmationPress,
    planName: name,
  });
  const prevVisible = usePrevious(isVisible);

  useEffect(() => {
    !isVisible && setPaymentOptions({});
    if (prevVisible && !isVisible) {
      onAddUsageClose && onAddUsageClose();
    }
  }, [isVisible, prevVisible]);
  return (
    <>
      <PlanExtrasModal
        toggleModal={toggleModal}
        planName={name}
        isVisible={isVisible}
        closeModal={closeModal}
        isLoading={isExtraPlanDataLoading}
        saveCardIsLoading={saveCardIsLoading}
        extraModalJson={extraModalJson}
        handleConfirmButtonPress={handleConfirmButtonPress}
        isLoadingSuccessful={isLoadingSuccessful}
        doneLoadingSubtitlePlaceholders={doneLoadingSubtitlePlaceholders}
        isResetData={isResetData}
        isPlansExtrasLoading={isPlansExtrasLoading}
        plansExtrasError={plansExtrasError}
        plansExtrasErrorScreenProps={plansExtrasErrorScreenProps}
        paymentOptions={paymentOptions}
        loadingFailureError={loadingFailureError}
        setPaymentOptions={setPaymentOptions}
        onAddUsageClose={onAddUsageClose}
        isCurrencyFirst={isCurrencyFirst}
      />
      <Plan
        toggleAddUsageModal={toggleAddUsageModal}
        containerStyle={planContainerStyle}
        isUser={isUser}
        isCurrencyFirst={isCurrencyFirst}
        name={name}
        {...props}
      />
    </>
  );
}

PlanWithExtrasModal.propTypes = {
  onAddUsageClose: PropTypes.func,
  addExtraPlanData: PropTypes.object,
  onAddUsageConfirmationPress: PropTypes.func,
  planContainerStyle: ViewPropTypes.style,
  isPlansExtrasLoading: PropTypes.bool,
  isUser: PropTypes.bool,
  isCurrencyFirst: PropTypes.bool,
  plansExtrasError: PropTypes.shape({
    message: PropTypes.string,
  }),
  plansExtrasErrorScreenProps: PropTypes.shape({
    title: PropTypes.string,
    onPrimaryBtnPress: PropTypes.func,
    primaryBtnTitle: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
};

export default PlanWithExtrasModal;
